export default __webpack_public_path__ + "static/media/Flag_of_Georgia.6828f829.svg";